import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { Paper } from '@mui/material';

function placeBar(el) {
    const vv = window.visualViewport;
    if (!el || !vv) return;
    const keyboardOpen = window.innerHeight - vv.height > 150;
    if (keyboardOpen) {
        el.style.visibility = 'hidden';
        return;
    }
    el.style.visibility = 'visible';
    const height = el.offsetHeight || 56;
    el.style.top = `${Math.max(0, vv.offsetTop + vv.height - height)}px`;
    el.style.bottom = 'auto';
    el.style.left = `${vv.offsetLeft}px`;
    el.style.width = `${vv.width}px`;
}

export default function MobileBottomBar({ children }) {
    const ref = useRef(null);

    useEffect(() => {
        const el = ref.current;
        const vv = window.visualViewport;
        const place = () => placeBar(el);
        place();
        vv?.addEventListener('resize', place);
        vv?.addEventListener('scroll', place);
        window.addEventListener('resize', place);
        window.addEventListener('orientationchange', place);
        return () => {
            vv?.removeEventListener('resize', place);
            vv?.removeEventListener('scroll', place);
            window.removeEventListener('resize', place);
            window.removeEventListener('orientationchange', place);
        };
    }, []);

    return createPortal(
        <Paper
            ref={ref}
            elevation={3}
            sx={{
                position: 'fixed',
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 1100,
                pb: 'env(safe-area-inset-bottom, 0px)',
            }}
        >
            {children}
        </Paper>,
        document.body
    );
}
